export default __webpack_public_path__ + "static/media/pd6.c388530a.jpg";